<ng-template #magnifierTemplate>
  <i class="cds-icon-search"></i>
</ng-template>
<div class="container-cash-flow">
  <caixa-webcomponent-navigation-bar />

  <caixa-webcomponent-header-accounts />

  <caixa-webcomponent-main-title text="Fluxo de caixa" />

  <div class="financial-records-container">
    <div class="filters-actions-wrapper" [class.no-dda-button]="!(showDdaButton$ | async)">
      <bfm-cash-flow-filters
        [showGroupingOptions]="false"
        [showTime]="true"
        [openModal]="true"
        [downloadEnabled]="(isDownloadEnabled$ | async) ?? false"
      />
      @if (showDdaButton$ | async) {
        <button
          id="financial-records-filter-button"
          class="cds-button s-hollow c-primary"
          (click)="openModal()"
        >
          Trazer Boletos Futuros (DDA)
        </button>
      }
    </div>

    <bfm-paginated-cash-flow
      [headers]="headers"
      [columnList]="columnsList$"
      [bankDetails]="true"
      [showExpansion]="false"
      [labelBalence]="' agrupado'"
    />
  </div>
</div>
